import React from 'react';
import ProductCarousel from './ProductCarousel';

const ProductCard = ({ product, onBuyNow }) => {
  return (
    <article className="product-card">
      <div className="product-image-wrapper">
        <ProductCarousel images={product.images} name={product.name} />
      </div>

      <div className="product-info">
        <span className="product-category">{product.category}</span>
        <h3 className="product-name">{product.name}</h3>
        <p className="product-price">Rs. {product.price.toLocaleString('en-IN')}</p>

        <button className="btn-buy-now" onClick={() => onBuyNow(product)}>
          Buy Now
        </button>
      </div>
    </article>
  );
};

export default ProductCard;
